import type { SettingsBillingClient } from "@cova/settings-core/contracts"
import { covaSettingsRpc } from "./settings-rpc"

/**
 * The platform's read of the acting firm's place at its payment wall (spec
 * multi-product 023 G55 (2); 018 P6, D37; FIX-PLATFORM-SALE-GATE): the
 * Billing group's `getPaymentStatus`, the one server-authoritative,
 * sale-gated answer the Bots wall and the PaymentWall read too, made over
 * this host's settings binding (R-021-1). Keyed by firm and scope, so one
 * firm's or scope's answer never stands in for another's.
 */
export const platformPaymentStatusKey = (orgId: string | null, scope: string) =>
  ["settings", "billing", "payment-status", orgId, scope] as const

type PaymentStatusReader = Pick<SettingsBillingClient, "getPaymentStatus">

export const platformPaymentStatusQuery = (
  orgId: string | null,
  scope: string,
  billing: () => PaymentStatusReader = () => covaSettingsRpc().billing,
) => ({
  queryKey: platformPaymentStatusKey(orgId, scope),
  queryFn: () => billing().getPaymentStatus({}),
  enabled: orgId !== null,
  staleTime: 60_000,
  refetchOnWindowFocus: false,
})
